Controller.$inject = [];

function Controller() {
}

export function HuiTr() {
    return {
        restrict: 'E',
        replace: true,
        scope: true,
        bindToController: {
            deleted: '<',
            highlighted: '<',
            isFooter: '<',
            expanded: '<',
            level: '<',
            loading: '<',
            parentLevel: '<',
            hasExpanded: '<',
            isHeader: '<'
        },
        controller: Controller,
        controllerAs: '$huiCtrl',
        transclude: true,
        template: ($element, $attrs) => {
            let style = '';
            if ($attrs.hasExpanded && $attrs.level !== undefined) {
                style += `--level: ${$attrs.level};`;
            }
            if ($attrs.hasExpanded && $attrs.parentLevel !== undefined) {
                style += `--parent-level: ${$attrs.parentLevel};`;
            }
            return `
               <tr ng-class="[
                        !!$huiCtrl.deleted ? 'deleted' : '',
                        !!$huiCtrl.highlighted ? 'highlighted' : '',
                        !!$huiCtrl.isFooter ? 'footer' : '',
                        !!$huiCtrl.isHeader ? 'is-header' : '',
                        !!$huiCtrl.hasExpanded ? 'has-expanded' : '',
                        !!$huiCtrl.hasExpanded && $huiCtrl.expanded === false ? 'row-closed' : '',
                        !!$huiCtrl.hasExpanded && $huiCtrl.expanded === true ? 'row-expanded' : '',
                        !!$huiCtrl.hasExpanded && !!$huiCtrl.loading ? 'loading' : ''
                        ]"
                       ${style ? `style="${style}"` : ''}
                      
               ng-transclude>
            </tr>
            `;
        }
    };
}



